import _ from "lodash";
import { DailyReport } from "../../DailyReport";

import "../../../assets/css/DailyReport.css"

class DepositByTypeDailyReport extends DailyReport {

    makeLabel(appLabel, reportLabel) {
        const regionKey = this.getRegionKeyFromSubgroup(this.getSubgroups()[0]);
        const regionLabel = regionKey === 'sg' ? 'Deposit Type' : 'Consumer & Corp';
        return super.makeLabel(appLabel, regionLabel);
    }
}

export { DepositByTypeDailyReport }
